import { render, staticRenderFns } from "./footerLanding.vue?vue&type=template&id=af512780&scoped=true&"
import script from "./footerLanding.vue?vue&type=script&lang=js&"
export * from "./footerLanding.vue?vue&type=script&lang=js&"
import style0 from "./footerLanding.vue?vue&type=style&index=0&id=af512780&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af512780",
  null
  
)

export default component.exports